"use strict";

require("core-js/modules/es.array.reduce.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.isHoursAvailable = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _lodash = require("lodash");

var _semanticUiReact = require("semantic-ui-react");

var _IconElement = _interopRequireDefault(require("../IconElement"));

require("./HoursOfOperation.css");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var HOURS_LABELS = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  7: 'Sunday'
};
var CLOSED_LABEL = 'Closed';
var OPEN_ALL_DAY_LABEL = 'Open 24 Hours';
var MOMENT_SUNDAY = 0;
var FISHERMAN_SUNDAY = 7;

var isHoursAvailable = function isHoursAvailable(hours) {
  return hours.filter(function (hour) {
    return hour.open || hour.close;
  }).length > 0;
};

exports.isHoursAvailable = isHoursAvailable;

var HoursOfOperation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(HoursOfOperation, _React$Component);

  var _super = _createSuper(HoursOfOperation);

  function HoursOfOperation() {
    (0, _classCallCheck2["default"])(this, HoursOfOperation);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(HoursOfOperation, [{
    key: "getHourGroups",
    value: function getHourGroups() {
      var _this = this;

      var _this$props = this.props,
          hours = _this$props.hours,
          timezone = _this$props.timezone,
          displayOption = _this$props.displayOption,
          startWithToday = _this$props.startWithToday;

      if (displayOption === 'daily' || displayOption === 'dailyWithPopup') {
        var dayMap = {};
        hours.forEach(function (_ref) {
          var day = _ref.day,
              open = _ref.open,
              close = _ref.close,
              label = _ref.label;

          if (!dayMap[day]) {
            dayMap[day] = {
              label: _this.formatLabel(label || HOURS_LABELS[day]),
              hoursValue: [],
              day: day,
              timezone: timezone,
              open: open,
              close: close
            };
          }

          dayMap[day] = _objectSpread({}, dayMap[day], {
            hoursValue: [].concat((0, _toConsumableArray2["default"])(dayMap[day].hoursValue), [_this.createTimeValue({
              open: open,
              close: close,
              day: day
            })])
          });
        });
        var daily = Object.values(dayMap);

        if ((startWithToday || displayOption === 'dailyWithPopup') && timezone) {
          daily = HoursOfOperation.setTodayFirstInArray(daily, timezone);
        }

        return daily;
      }

      return this.groupHours();
    }
  }, {
    key: "groupHours",
    value: function groupHours() {
      var _this2 = this;

      var hours = this.props.hours; // Create a dict with day as key and a list of hourString as value

      var dayToHourStringList = {};
      hours.forEach(function (hourObj) {
        var day = hourObj.day,
            open = hourObj.open,
            close = hourObj.close;

        if (!dayToHourStringList[day]) {
          dayToHourStringList[day] = [];
        }

        var hourString = _this2.createTimeValue({
          open: open,
          close: close,
          day: day
        });

        dayToHourStringList[day].push(hourString);
      }); // Group consecutive days with the same list of hourString
      // Create a list of objects, where each object has 3 values: hoursValue, start day, end day

      var orderedDays = Object.keys(dayToHourStringList).map(function (k) {
        return parseInt(k, 10);
      });
      orderedDays.sort();
      var groups = [];
      var startDayForGroup = orderedDays[0];
      var previousDay = orderedDays[0];
      var currentDayHourStr = null;
      var previousDayHourStr = null;
      orderedDays.forEach(function (currentDay, currentIndex) {
        if (currentIndex !== 0) {
          // The idea is to compare day string by day string and while they
          // are the same they will be grouped together. Every group is split
          // when a day string is different to the previous one or some edge cases
          // when we are checking the last day of the week
          previousDay = orderedDays[currentIndex - 1];
          currentDayHourStr = dayToHourStringList[currentDay].join(',');
          previousDayHourStr = dayToHourStringList[previousDay].join(',');

          if (currentDayHourStr !== previousDayHourStr && currentIndex !== orderedDays.length - 1) {
            groups.push({
              hoursValue: dayToHourStringList[previousDay],
              startDay: startDayForGroup,
              endDay: previousDay
            });
            startDayForGroup = currentDay;
          } else if (currentDayHourStr === previousDayHourStr && currentIndex === orderedDays.length - 1) {
            groups.push({
              hoursValue: dayToHourStringList[previousDay],
              startDay: startDayForGroup,
              endDay: currentDay
            });
          } else if (currentDayHourStr !== previousDayHourStr && currentIndex === orderedDays.length - 1) {
            groups.push({
              hoursValue: dayToHourStringList[previousDay],
              startDay: startDayForGroup,
              endDay: previousDay
            });
            groups.push({
              hoursValue: dayToHourStringList[currentDay],
              startDay: currentDay,
              endDay: currentDay
            });
          }
        }
      });
      return groups.map(function (_ref2) {
        var hoursValue = _ref2.hoursValue,
            startDay = _ref2.startDay,
            endDay = _ref2.endDay;
        var hoursGroupLabel;

        if (startDay === endDay) {
          hoursGroupLabel = _this2.createLabel({
            day: startDay
          });
        } else {
          hoursGroupLabel = _this2.createLabel({
            day: startDay
          }, {
            day: endDay
          });
        }

        return {
          label: hoursGroupLabel,
          hoursValue: hoursValue
        };
      });
    }
  }, {
    key: "isOpenAllDay",
    value: function isOpenAllDay(day) {
      var hours = this.props.hours; // Get all opening hours for day

      var hoursForDay = hours.reduce(function (acc, opHour) {
        if (opHour.day === day - 1) {
          if (opHour.close <= opHour.open) {
            // it closes after midnight
            return [].concat((0, _toConsumableArray2["default"])(acc), [{
              open: 0,
              close: opHour.close
            }]);
          }
        }

        if (opHour.day === day) {
          return [].concat((0, _toConsumableArray2["default"])(acc), [{
            open: opHour.open,
            close: opHour.close
          }]);
        }

        return (0, _toConsumableArray2["default"])(acc);
      }, []); // Ensure all hours are sorted by open key

      hoursForDay.sort(function (a, b) {
        return a.open - b.open;
      }); // Check that hours for day covers the whole day without any gap

      if (hoursForDay.length === 1) {
        return hoursForDay[0].open === 0 && hoursForDay[0].close === 0;
      }

      var openAllDay = hoursForDay[0].open === 0;

      for (var i = 1; i < hoursForDay.length; i += 1) {
        // Check that every split hour is attached to the next
        openAllDay = openAllDay && hoursForDay[i - 1].close >= hoursForDay[i].open;

        if (i === hoursForDay.length - 1) {
          // Check that the last hour closes at midnight or after it
          openAllDay = openAllDay && (hoursForDay[i].close <= hoursForDay[i].open || hoursForDay[i].close === 0);
        }
      }

      return openAllDay;
    }
  }, {
    key: "createTimeValue",
    value: function createTimeValue(_ref3) {
      var open = _ref3.open,
          close = _ref3.close,
          day = _ref3.day;
      if (HoursOfOperation.isClosed(open, close)) return CLOSED_LABEL;
      if (this.isOpenAllDay(day)) return OPEN_ALL_DAY_LABEL;
      var openTime = HoursOfOperation.getTimeMoment(open);
      var openString = HoursOfOperation.getFormattedTimeMoment(openTime);
      var closeTime = HoursOfOperation.getTimeMoment(close);
      var closeString = HoursOfOperation.getFormattedTimeMoment(closeTime);
      return "".concat(openString, " - ").concat(closeString);
    }
  }, {
    key: "createLabel",
    value: function createLabel(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var firstLabel = this.formatLabel(a.label || HOURS_LABELS[a.day]);

      if (b !== null) {
        var secondLabel = this.formatLabel(b.label || HOURS_LABELS[b.day]);
        return "".concat(firstLabel, " - ").concat(secondLabel);
      }

      return firstLabel;
    }
  }, {
    key: "formatLabel",
    value: function formatLabel(label) {
      var _this$props2 = this.props,
          capitalizeLabels = _this$props2.capitalizeLabels,
          truncateLabels = _this$props2.truncateLabels;
      var displayedLabel = truncateLabels ? label.slice(0, 3) : label;
      return capitalizeLabels ? displayedLabel.toUpperCase() : displayedLabel;
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props3 = this.props,
          header = _this$props3.header,
          subheader = _this$props3.subheader;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, header && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h2"
      }, header), subheader && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h3"
      }, subheader));
    }
  }, {
    key: "renderHours",
    value: function renderHours() {
      var _this$props4 = this.props,
          orientation = _this$props4.orientation,
          animated = _this$props4.animated,
          celled = _this$props4.celled,
          inlineHours = _this$props4.inlineHours;
      var hourGroups = this.getHourGroups();
      var isHorizontal = orientation === 'horizontal';
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List, {
        horizontal: isHorizontal,
        animated: animated,
        celled: celled,
        relaxed: true
      }, hourGroups.map(function (_ref4) {
        var label = _ref4.label,
            hoursValue = _ref4.hoursValue;
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Item, {
          key: label
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Content, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Header, {
          as: "h4"
        }, label, inlineHours && ": ".concat(hoursValue.join(' | '))), !inlineHours && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Description, null, /*#__PURE__*/_react["default"].createElement("ul", {
          className: "unstyled-list"
        }, hoursValue.map(function (hour) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: hour
          }, hour);
        })))));
      }));
    }
  }, {
    key: "renderDailyWithPopup",
    value: function renderDailyWithPopup() {
      var displayOpenClosedStatus = this.props.displayOpenClosedStatus;
      var days = this.getHourGroups();
      var firstDay = days[0];
      var open = firstDay.open,
          close = firstDay.close,
          day = firstDay.day,
          timezone = firstDay.timezone;
      var hoursString = firstDay.hoursValue.join(' | ');
      var visibleFirstDay;

      if (displayOpenClosedStatus && timezone) {
        var currentlyOpenLabel = HoursOfOperation.getCurrentlyOpenLabel(open, close, day, timezone);
        visibleFirstDay = /*#__PURE__*/_react["default"].createElement("div", {
          className: "hoo-withpopup-first"
        }, currentlyOpenLabel, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
          name: "caret down"
        }));
      } else {
        visibleFirstDay = /*#__PURE__*/_react["default"].createElement("div", {
          className: "hoo-withpopup-first"
        }, /*#__PURE__*/_react["default"].createElement("h4", null, firstDay.label), /*#__PURE__*/_react["default"].createElement("p", {
          className: "hoo-hours-paragraph"
        }, hoursString), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
          name: "caret down"
        }));
      }

      var content = this.renderHours();
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Popup, {
        trigger: visibleFirstDay,
        content: content,
        basic: true,
        on: "click"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          className = _this$props5.className,
          showIcon = _this$props5.showIcon,
          displayOption = _this$props5.displayOption,
          iconAs = _this$props5.iconAs,
          hours = _this$props5.hours;

      if (!isHoursAvailable(hours)) {
        return null;
      }

      if (displayOption === 'dailyWithPopup') {
        return this.renderDailyWithPopup();
      }

      var content = /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, this.renderHeader(), this.renderHours());

      if (displayOption === 'modal') {
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal, {
          className: "hoo-modal",
          dimmer: "inverted",
          trigger: iconAs === 'icon' ? /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "hoo-modal-trigger"
          }, /*#__PURE__*/_react["default"].createElement(_IconElement["default"], {
            iconType: "clock",
            element: /*#__PURE__*/_react["default"].createElement("a", null, "See Hours"),
            iconPosition: "left"
          })) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
            icon: "clock",
            secondary: true
          })
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, null, /*#__PURE__*/_react["default"].createElement("div", null, "Hours Of Operation")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, null, content));
      }

      return showIcon ? /*#__PURE__*/_react["default"].createElement(_IconElement["default"], {
        iconType: "clock",
        element: content,
        iconPosition: "top"
      }) : content;
    }
  }], [{
    key: "timesAreEqual",
    value: function timesAreEqual(a, b) {
      return a.open === b.open && a.close === b.close;
    }
    /**
     * Returns an empty string if it's not today or no timezone is set, else Open or Closed.
     * Inspired on https://stackoverflow.com/a/59492313
     */

  }, {
    key: "getCurrentlyOpenLabel",
    value: function getCurrentlyOpenLabel(open, close, day, timezone) {
      // Can't be totally sure without a timezone,
      // so don't do this if we don't have one.
      if (!timezone) {
        return '';
      } // If weekday isn't today.


      var now = _momentTimezone["default"].tz(timezone);

      var weekDayIso = now.isoWeekday();

      if (weekDayIso !== day) {
        return '';
      }

      var openTimeString = open.toString().padStart(4, '0');

      var openMoment = _momentTimezone["default"].tz(openTimeString, 'hmm', timezone);

      var closeTimeString = close.toString().padStart(4, '0');

      var closeMoment = _momentTimezone["default"].tz(closeTimeString, 'hmm', timezone);

      var label = /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: 'red'
        }
      }, "Closed");

      if (closeMoment.isBefore(openMoment) || openMoment.isSame(closeMoment)) {
        // Handle ranges that span over midnight
        if (now.isAfter(openMoment)) {
          label = /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              fontWeight: 'bold'
            }
          }, "Open");
        }
      } else if (now.isBetween(openMoment, closeMoment, null, '[)')) {
        // Normal range check using an inclusive start time and exclusive end time
        label = /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            fontWeight: 'bold'
          }
        }, "Open");

        if (closeMoment.diff(now, 'minutes') <= 15) {
          label = /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              fontWeight: 'bold'
            }
          }, "Closing soon");
        }
      }

      return label;
    }
  }, {
    key: "getTimeMoment",
    value: function getTimeMoment(timeInt) {
      var timeString = timeInt.toString().padStart(4, '0');
      return (0, _momentTimezone["default"])(timeString, 'hmm');
    }
  }, {
    key: "getFormattedTimeMoment",
    value: function getFormattedTimeMoment(timeMoment) {
      if (timeMoment.isSame((0, _momentTimezone["default"])(timeMoment).startOf('day'))) {
        return 'Midnight';
      }

      return timeMoment.format('h:mma');
    }
  }, {
    key: "getFormattedTime",
    value: function getFormattedTime(time) {
      return HoursOfOperation.getFormattedTimeMoment(HoursOfOperation.getTimeMoment(time));
    }
  }, {
    key: "isClosed",
    value: function isClosed(open, close) {
      return HoursOfOperation.openOrCloseIsInvalid(open, close);
    }
  }, {
    key: "openOrCloseIsInvalid",
    value: function openOrCloseIsInvalid(open, close) {
      return !(0, _lodash.isNumber)(open) || !(0, _lodash.isNumber)(close);
    }
  }, {
    key: "getMomentFromInt",
    value: function getMomentFromInt(hourInt, date) {
      return (0, _momentTimezone["default"])("".concat(date, " ").concat(hourInt), 'DD hmm');
    }
  }, {
    key: "getMomentForTimezone",
    value: function getMomentForTimezone(timezone) {
      if (timezone) {
        return (0, _momentTimezone["default"])().tz(timezone);
      }

      return (0, _momentTimezone["default"])();
    }
  }, {
    key: "convertMomentDay",
    value: function convertMomentDay(momentDay) {
      var todayInt = parseInt(momentDay.format('d'), 10);
      return todayInt === MOMENT_SUNDAY ? FISHERMAN_SUNDAY : todayInt;
    }
  }, {
    key: "setTodayFirstInArray",
    value: function setTodayFirstInArray(hours, timezone) {
      var todayMoment = HoursOfOperation.getMomentForTimezone(timezone);
      var todayInt = HoursOfOperation.convertMomentDay(todayMoment);
      var shiftHours = (0, _toConsumableArray2["default"])(hours);

      for (var i = 0; i < todayInt - 1; i += 1) {
        shiftHours.push(shiftHours.shift());
      }

      return shiftHours;
    }
  }]);
  return HoursOfOperation;
}(_react["default"].Component);

exports["default"] = HoursOfOperation;
HoursOfOperation.propTypes = {
  hours: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    day: _propTypes["default"].number.isRequired,
    open: _propTypes["default"].number.isRequired,
    close: _propTypes["default"].number.isRequired,
    label: _propTypes["default"].string
  })).isRequired,
  animated: _propTypes["default"].bool,
  capitalizeLabels: _propTypes["default"].bool,
  celled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  displayOption: _propTypes["default"].oneOf(['daily', 'dailyWithPopup', 'grouped', 'modal']),
  displayOpenClosedStatus: _propTypes["default"].bool,
  startWithToday: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  inlineHours: _propTypes["default"].bool,
  iconAs: _propTypes["default"].string,
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  showIcon: _propTypes["default"].bool,
  subheader: _propTypes["default"].string,
  timezone: _propTypes["default"].string,
  truncateLabels: _propTypes["default"].bool
};
HoursOfOperation.defaultProps = {
  animated: false,
  capitalizeLabels: false,
  celled: false,
  className: '',
  displayOption: 'daily',
  displayOpenClosedStatus: false,
  startWithToday: false,
  header: '',
  inlineHours: false,
  iconAs: 'icon',
  orientation: 'vertical',
  showIcon: false,
  subheader: '',
  timezone: null,
  truncateLabels: false
};
HoursOfOperation.propOptions = {
  header: ['Hours of Operation', 'Our Hours', '']
};
HoursOfOperation.dataPropsMap = {
  hours: ['business', 'primary_location', 'hours']
};